/*
 * Copyright (c) 2020. Legalbird eine Marke der R&S Internet Jewels GmbH
 */

import { Theme } from "@mui/material";

const error404PageStyle = {
  container: (theme: Theme) => ({
    overflow: "hidden",
    paddingBottom: "4rem",
    [theme.breakpoints.up("md")]: {
      paddingBottom: "11rem",
    },
  }),
  textColumn: (theme: Theme) => ({
    [theme.breakpoints.up("md")]: {
      order: -1,
    },
  }),
  logoBird: (theme: Theme) => ({
    color: theme.palette.brand.steel,
    maxWidth: "100%",
    height: "auto",
    transform: "translateY(-5rem)",
    marginBottom: "-5rem",
    [theme.breakpoints.up("md")]: {
      transform: "translateY(-8rem)",
      marginBottom: "-8rem",
    },
  }),
};

export default error404PageStyle;
